function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Critical Pr");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "ToDoList_Dashboard",
  transform: "translate(-312.000000, -403.000000)"
}, React.createElement("g", {
  id: "Your-To-do's",
  transform: "translate(265.000000, 275.000000)"
}, React.createElement("g", {
  id: "Task_1",
  transform: "translate(32.000000, 112.000000)"
}, React.createElement("g", {
  id: "Critical-Pr",
  transform: "translate(15.000000, 16.000000)"
}, React.createElement("rect", {
  id: "Rectangle",
  className: "iconFill",
  opacity: 0.100000001,
  x: 0,
  y: 0,
  width: 25,
  height: 25,
  rx: 8
}), React.createElement("rect", {
  id: "Rectangle-Copy-21",
  className: "iconStroke",
  strokeWidth: 0.5,
  x: 7.50806452,
  y: 7.50806452,
  width: 9.98387097,
  height: 9.98387097,
  rx: 4
}), React.createElement("circle", {
  id: "Oval",
  className: "iconFill",
  cx: 15.9274194,
  cy: 8.66935484,
  r: 2.21774194
}))))));

var SvgFilterIcon = function SvgFilterIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFilterIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FilterIcon.98384d0b.svg";
export { ForwardRef as ReactComponent };